//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Card from "../Card/Card";
import Icon from "../Icon/Icon";
import Btn from "../Button/Btn";
import Sizeable from "../../mixins/Sizeable";
import Loadable from "../../mixins/Loadable";
import Box from "../Layout/Box";
import CardText from "../Card/CardText";
import Wrapper from "../Layout/Wrapper";
import Popup from "../Popup/Popup";
import Toggleable from "../../mixins/Toggleable";

export default {
    name: 'Modal',

    components: {CardText, Box, Btn, Icon, Card, Popup, Wrapper},

    mixins: [Toggleable, Sizeable, Loadable],

    props: {

        // Whether the modal shall be put as highest z-index position if multiple modals and popovers are displayed at the same time
        highestOrder: {
            type: Boolean,
            default: false
        },

        // The order number of the modal if multiple modals are displayed at the same time
        // Is equal to a CSS 'z-index'
        order: {
            type: Number,
            default: null
        },

        title: {
            type: String,
            default: null
        },

        subtitle: {
            type: String,
            default: null
        },

        contentClass: {
            type: String | Object | Array,
            default: ''
        },

        showCloseButton: {
            type: Boolean,
            default: true
        },

        closeable: {
            type: Boolean,
            default: true
        },

        persistent: {
            type: Boolean,
            default: false
        },

        // Whether the modal content shall no have any content
        noPadding: {
            type: Boolean,
            default: false
        },

        // A promise function that returns a boolean to check if the modal can be canceled.
        cancelCheck: {
            type: Function,
            default: null
        },

        fullscreen: {
            type: Boolean,
            default: false
        },

        mobileFullscreen: {
            type: Boolean,
            default: true
        },

        width: {
            type: [Number, String],
            default: null
        },

        buttonBreakColumn: {
            type: String,
            default: null
        }
    },

    computed: {

        isFullscreen() {
            return this.fullscreen || (this.mobileFullscreen && this.$breakpoint.smAndDown);
        },

        modalWidth() {
            if (this.isFullscreen) {
                return '100vw';
            }

            if (this.width) {
                return this.width;
            }

            switch (this.sizeString) {
                case 'xl':
                    return '1200';
                case 'lg':
                    return '900';
                case 'sm':
                    return '500';
            }

            return '650';
        },

        modalHeight() {
            if (this.isFullscreen) {
                return '100%';
            }

            return null;
        },

        maxModalHeight() {
            if (this.isFullscreen) {
                return '100%';
            }

            return '90vh';
        }
    },

    watch: {
        isActive(active) {
            if (active) {
                this.$emit('show');
            } else {
                this.$emit('hide');
            }
        }
    },

    methods: {
        cancel() {
            if (this.cancelCheck) {
                this.cancelCheck().then(({confirmed}) => {
                    if (confirmed) {
                        this.cancelNow();
                    }
                })
            } else {
                this.cancelNow();
            }
        },

        cancelNow() {
            this.isActive = false;
            this.handleCanceled();
        },

        handleCanceled() {
            this.$emit('cancel');
        }

    }
}
